
const routes = [
  {
    path: "/connect-zoom-page",
    name: "zoomPage",
    component: () => import(/* webpackChunkName: "ZoomPage" */ "./views/ZoomPage")
  },
  {
    path: "/connect-zoom-dialog",
    name: "zoomDialog",
    component: () => import(/* webpackChunkName: "ZoomDialog" */ "./views/ZoomDialog")
  }
];

export default routes;
